<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div>
    <div class="scrollable-mode"> 
    </div>
    <div class="performance-compare-group-by">
      <el-select
      v-model="selectedDateRange"
      collapse-tags
      size="mini"
      style="margin-left: 5px;"
      class="date-range-dropdown"
      popper-class="table-filter-dropdown bes-bas-date-range"
      :popper-append-to-body="false"
      @change="dateRangeChanged(selectedDateRange)">
        <el-option
          v-for="(item) in dateRangeTypes"
          :disabled="item.disabled"
          :key="item.type"
          :label="item.label"
          :value="item.type">
        </el-option>
      </el-select>
    </div>
    <div ref="chart" class="wy-home-line-chart" :id="chartId"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import WyChartUtils from '../../panel-views/utils/wy-chart-util.js';
import WyUtils from '../../../library/wy-utils.js';
export default Vue.extend({
  name: 'wy-home-line-chart',
  props: ['controller', 'chartId', 'lineChartData', 'type'],

  data() {
    return {
      module: this,
      loading: false,
      scrollableMode: false,
      allValueZero: true,
      tickformat: '',
      lineColor: '#1C4DB2',
      localData: null,
      localMedian: null,
      hasRegressionData: true,
      hasSingleValidData: false,

      selectedDateRange: null,
      dateRangeTypes: {
        'month': {
            type: 'month',
            label: 'View by month',
            tickformat: '%b %Y',
            duraion: 99999,
            disabled: false
        },
        'week': {
            type: 'week',
            label: 'View by week',
            tickformat: '%b %d %Y',
            duraion: 30,
            disabled: false
        },
        'day': {
            type: 'day',
            label: 'View by day',
            tickformat: '%b %d %Y',
            duraion: 7,
            disabled: false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['dataModel', 'legendColors', 'companyConfig']),
  },
  methods: {
    handleDateChange(type){
      if(type == 'year'){
        this.tickformat = '%Y'
      } else if (type == 'quarter'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'week'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'day'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'month'){
        this.tickformat = '%b %Y'
      }
    },

    toggleLegend(toggleLengend, flag) {
      this.hasRegressionData = flag;
      if(flag) {
        this.localData.forEach((item, itemIndex) => {
          if(item.lineChartData.legends[0] == toggleLengend) {
            item.lineChartData.yAxisData.forEach((value, index) => {
              item.lineChartData.yAxisData[index] = this.lineChartData[itemIndex].lineChartData.yAxisData[index];
            })
          }
        })
      }
      else {
        // this.localData = JSON.parse(JSON.stringify(this.lineChartData));
        this.localData.forEach(item => {
          if(item.lineChartData.legends[0] == toggleLengend) {
            item.lineChartData.yAxisData.forEach((value, index) => {
              item.lineChartData.yAxisData[index] = null
            })
          }
        })
      }
      this.buildChart('legend');
    },

    handleScrollableMode() {
      this.buildChart('scrollable')
    },

    buildChart(mode) {
      if(!this.selectedDateRange) {
        this.initDateRangeRules();
      }
      
      setTimeout(()=>{
        this.lineChartData.forEach((chartData) => {
          chartData.lineChartData.hoverTextList = [];
          chartData.lineChartData.yAxisData.forEach((yVal) => {
            // if(yVal == -1 && (indexY == 2 || indexY == 3)) {
            //   this.localData[index].lineChartData.yAxisData[indexY] = 0
            //   let val =  '0%'
            //   chartData.lineChartData.hoverTextList.push(val);
            // }
            if(yVal == -1) {
              chartData.lineChartData.hoverTextList.push('N/A');
            }
            else {
              if(chartData.lineChartData.suffix == '%') {
                let val = yVal.toFixed(0)
                chartData.lineChartData.hoverTextList.push(val);
              }
              else {
                chartData.lineChartData.hoverTextList.push(WyUtils.formatterNumber(yVal.toFixed(0)));
              }
            }
          })
        });
        if(!mode) {
          this.localData = JSON.parse(JSON.stringify(this.lineChartData));
        }
        
        let data = [];
        let firstTrace = this.localData[0].lineChartData
        // this.localData[0].lineChartData.yAxisData = [1, 34, 54]
        // this.localData[1].lineChartData.yAxisData = [1, 34, 54]
        this.localData.forEach((chartData, index) => {
          let colors = [];
          chartData.lineChartData.xAxisData.forEach(() => {
            colors.push('transparent');
          });
          this.allValueZero = true;
          chartData.lineChartData.yAxisData.forEach(yVal => {
            if(yVal != 0) {
              this.allValueZero = false;
            }
          })
          var traceData = {
            x: chartData.lineChartData.xAxisData,
            y: chartData.lineChartData.yAxisData,
            name:'',
            type: 'scatter',
            mode: "lines+markers",
            cliponaxis: false,
            marker: {color: (this.checkSingleChartData(chartData.lineChartData.yAxisData))? chartData.lineChartData.legendColors[index]:'transparent', size: 6},
            hoverinfo: 'x',
            showlegend: false,
            hoverlabel: {
              bgcolor: chartData.lineChartData.legendColors[index],
              font: {
                size: 13,
                weight: 700,
                family: 'Helvetica Neue, Helvetica, arial, sans-serif'
              },
              namelength: 50,
              bordercolor: '#FFFFFF',
              beckgroundcolor: 'black'
            },
            fill: 'none',
            line: {
              color: chartData.lineChartData.legendColors[index],//'#6567CA',
              width: 1.5
            },    
            hovertext: chartData.lineChartData.hoverTextList,
            // hovertemplate: "%{hovertext}<extra></extra>" //this.wyChart.hoverTemplateNoDate("d"),      
            hovertemplate: " " + "<b>"+chartData.lineChartData.legends[0]+"<b>" + " <br /> " + chartData.lineChartData.prefix + "%{hovertext}" + chartData.lineChartData.suffix
          };
          // this code only handle bes and bas chart to remove the no-data points
          traceData.y.forEach((val, index) => {
            if(this.lineChartData && this.lineChartData.length > 0 && this.lineChartData[0].key == 'bes') {
              if(val < 0) {
                traceData.y[index] = null
              }
            }
          })
          data.push(traceData)
        })

        let layout = {
          margin: { l: 50, r: 50, t: 25 , b: 20, pad: 10},
          autosize: true,
          hovermode: 'x',
          // title: {
          //   text: this.type,
          //   font: {
          //     size: 12
          //   },
          //   y:  0.99,
          //   x: 0.94
          // },
          height: 300,
          // width: 100%,
          dragmode: false,
          // showlegend: true,
          legend: {
            orientation: 'h',
            x: 0.41,
            y: -0.5
          },
          xaxis:  {
            autorange: true,
            fixedrange: true,
            // autorange: false,
            // fixedrange: false,
            // range: defaultRange,
            showgrid: false,
            zeroline: false,
            automargin: true,
            showline: true,
            
            // position: 0,
            // linecolor: 'transparent',
            // rangeselector: selectorOptions,
            rangeslider: {autorange: true},
            side: 'bottom'
          },
          yaxis: {
            type: 'linear',
            autorange: true,
            // rangemode: 'tozero',
            rangemode: "nonnegative",
            separatethousands: true,
            showgrid: true,
            // zeroline: false,
            zeroline: true,
            side: 'right',
            showline: true,
            linecolor: '#edeff0',
            // layer: 'below traces',
            fixedrange: true,
          }
        }
        if(this.type) {
          // console.log(this.type)
          this.handleDateChange(this.type)
        }
        
        
        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        if(firstTrace.suffix == '%') {
          layout.yaxis.range = [0, 100];
        }
        if(firstTrace.xAxisData.length > 1 && firstTrace.xAxisData.length < 5) {
          layout.xaxis.nticks = firstTrace.xAxisData.length;
          layout.xaxis.tickformat = this.tickformat;
          if(this.type == 'year') {
            layout.xaxis.tickformat = null;
          }
        }
        if(firstTrace.xAxisData.length == 1) {
          layout.xaxis.nticks = 3;
          // layout.xaxis.tickformat = '%b %d %Y'
          if(firstTrace.marker) {
            firstTrace.marker.color = '#214586';
          }
        } 
        if(firstTrace.xAxisData.length < 5) {
          layout.xaxis.nticks = firstTrace.xAxisData.length;
          // layout.xaxis.tickformat = '%b %d %Y'
        }
        if(firstTrace.xAxisData.length > 5) {
        // if(firstTrace.xAxisData.length >= 5 && firstTrace.xAxisData.length < 10) {
        //   layout.xaxis.nticks = 5;
        //   layout.xaxis.tickformat = this.tickformat;
        // }
        // if(firstTrace.xAxisData.length >= 10) {
          // if(!this.scrollableMode) {
          layout.xaxis.tickmode = 'array';
          layout.xaxis.tickvals = [firstTrace.xAxisData[0], firstTrace.xAxisData[Math.round((firstTrace.xAxisData.length - 1)/3)], firstTrace.xAxisData[Math.round((firstTrace.xAxisData.length - 1)/3)*2], firstTrace.xAxisData[firstTrace.xAxisData.length-1]]
          // }
          layout.xaxis.nticks = 3;
          layout.xaxis.tickformat = this.tickformat;
        }

        if(firstTrace.xAxisData.length == 5) {
          layout.xaxis.tickmode = 'array';
          layout.xaxis.tickvals = [firstTrace.xAxisData[0], firstTrace.xAxisData[Math.round((firstTrace.xAxisData.length - 1)/2)], firstTrace.xAxisData[firstTrace.xAxisData.length-1]]
          layout.xaxis.nticks = 3;
          layout.xaxis.tickformat = this.tickformat;
        }

        // console.log(this.type, this.dataModel)
        let xLength = firstTrace.xAxisData.length
        // if(!mode) {
        //   if(xLength < 20 || this.allValueZero) {
        //     this.scrollableMode = false;
        //   }
        //   else {
        //     this.scrollableMode = true;
        //   }
        // }
        if(this.type == 'day') {
          WyChartUtils.scrollableChartSetLayoutByDay(firstTrace.xAxisData, xLength, layout)
        }
        if(this.type == 'week') {
          WyChartUtils.scrollableChartSetLayoutByWeek(xLength, layout)
        }
        if(this.type == 'month') {
          WyChartUtils.scrollableChartSetLayoutByMonth(xLength, layout)
        }
        if(this.type == 'year') {
          WyChartUtils.scrollableChartSetLayoutByYear(xLength, layout)
        }
        // if(!this.scrollableMode) {
          layout.xaxis.autorange = true;
          layout.xaxis.rangeslider = null; 
        // }
        // else {
        //   layout.xaxis.autorange = false;
        //   layout.xaxis.rangeslider = {autorange: true, thickness: 0.1}
        // }
        // if(this.hasRegressionData) {
        //   data.push(traceRegression)
        // }
        if(!mode || mode != 'legend') {
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, layout, config);
        }
        else {
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, this.$refs.chart.layout, this.$refs.chart.config);
        }
        this.$refs.chart.on('plotly_hover', (data) => {     
          try {
            data.points.forEach((point)=>{
              let dataPoint = point//data.points[0];
              if(dataPoint && dataPoint.data && dataPoint.data.marker) {  
                let pn = dataPoint.pointNumber;
                let colors = [];
                this.localData[0].lineChartData.xAxisData.forEach(() => {
                  colors.push('transparent');
                });
                colors[pn] = dataPoint.data.line.color
                point.data.marker =  {color: colors}
                // eslint-disable-next-line no-undef
                Plotly.relayout(this.$refs.chart, point.data.marker, 0);
              }
            })
          }
          catch {
            // catch error
          }
        });

        // mouse out on point
        this.$refs.chart.on('plotly_unhover', (data) => {
          try {
            data.points.forEach((point)=>{
              let dataPoint = point//data.points[0];
              if(dataPoint && dataPoint.data && dataPoint.data.marker) {  
                let colors = [];
                if(!this.checkSingleChartData(dataPoint.data.y)) {
                  dataPoint.data.y.forEach(()=>{
                    colors.push('transparent');
                  })
                }
                else {
                  dataPoint.data.y.forEach(()=>{
                    colors.push(dataPoint.data.line.color);
                  })
                }
                point.data.marker =  {color: colors}
                // eslint-disable-next-line no-undef
                Plotly.relayout(this.$refs.chart, point.data.marker, 0);
              }
            })
          }
          catch {
            // catch error
          }
        });
      }, 50)
    },

    checkSingleChartData(data) {
      if(data.length > 1) {
        let validVumber = 0;
        data.forEach(value => {
          if(value != null && value >= 0) {
            validVumber ++
          }
        })
        if(validVumber > 1) {
          return false;
        }
        else {
          return true;
        }
      }
      else {
        return true;
      }
    },

    dateRangeChanged(selectedDateRange) {
      if(!this.controller.pannelData.filterSettings || this.controller.overviewData) {
        this.controller.changeDateRange(selectedDateRange)
      }
    },

    initDateRangeRules() {
      let dateStartMoment = moment(this.dataModel.dateStart,'YYYY-MM-DD');
      let dateEndMoment = moment(this.dataModel.dateEnd,'YYYY-MM-DD');
      this.dateRangeDatesDiff = dateEndMoment.diff(dateStartMoment, 'days', true) + 1;
      const sortedDateRangeTypes = Object.values(this.dateRangeTypes).sort((a, b) => (a.duraion - b.duraion));
      for(const item of sortedDateRangeTypes) {
        if(this.dateRangeDatesDiff < item.duraion) {
          item.disabled = false;
          sortedDateRangeTypes.filter(otherItem => otherItem.type!=item.type).map(otherItem => {
            otherItem.disabled = (otherItem.duraion > item.duraion);
          });
          break;
        }
      }
      let chartViewBy = (this.companyConfig.default || {}).selectedViewBy || "week"

      if(this.dateRangeTypes.day && !this.dateRangeTypes.day.disabled && chartViewBy && chartViewBy.dailyWithinDays && this.dateRangeDatesDiff <= chartViewBy.dailyWithinDays) {
        this.selectedDateRange = 'day'
      }
      else if(this.dateRangeTypes.week && !this.dateRangeTypes.week.disabled && chartViewBy && chartViewBy.weeklyWithinDays && this.dateRangeDatesDiff <= chartViewBy.weeklyWithinDays) {
        this.selectedDateRange = 'week'
      }
      else if(this.dateRangeTypes.month && !this.dateRangeTypes.month.disabled && chartViewBy && chartViewBy.monthlyWithinDays && this.dateRangeDatesDiff <= chartViewBy.monthlyWithinDays) {
        this.selectedDateRange = 'month'
      }
      else if(this.dateRangeTypes.quarter && !this.dateRangeTypes.quarter.disabled && chartViewBy && chartViewBy.quarterlyWithinDays && this.dateRangeDatesDiff <= chartViewBy.quarterlyWithinDays) {
        this.selectedDateRange = 'quarter'
      }
      else if(this.dateRangeTypes.year && !this.dateRangeTypes.year.disabled && chartViewBy && chartViewBy.yearlyWithinDays && this.dateRangeDatesDiff <= chartViewBy.yearlyWithinDays) {
        this.selectedDateRange = 'year'
      }
      else {
        // get default date range type      
        for(const item of sortedDateRangeTypes) {
          if(this.dateRangeDatesDiff < item.duraion) {
            this.selectedDateRange = item.type;
            break;
          }
        }
      }
    }
  },

  mounted(){
    this.localData = JSON.parse(JSON.stringify(this.lineChartData));
    this.buildChart();

    this.$root.$on(`fire-selected-date-change-events`, (type) => {
        this.handleDateChange(type)
      }
    )
  }
});
</script>
 
<style lang="scss">
  .wy-home-line-chart {
    position: relative;
    // right: 20px;
    // width: 450px;
    // bottom: 40px;
    .plotly .cursor-crosshair {
      cursor: pointer;
    }

    g.yaxislayer-above .ytick text {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    g.xaxislayer-above .xtick text{
      font-size: 0.5vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    .legendtext {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    g.zerolinelayer {
      path.yzl.zl.crisp {
        stroke: rgb(238, 238, 238) !important;
      }
    }
    rect.rangeslider-slidebox {
      cursor: grab !important;
    }
    // .xtick {
    //   text {
    //     font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    //   }
    // }
    .cursor-ew-resize, .cursor-w-resize, .cursor-e-resize {
      cursor: default !important;
    }
    rect.rangeslider-mask-min, rect.rangeslider-mask-max {
      fill: #888888 !important;
      fill-opacity: 0.5 !important;
    }
  }
  .wy-home-line-chart.js-plotly-plot .plotly .cursor-ns-resize {
    cursor: pointer !important;
    // cursor: move !important;
  }
  .dragcover {
    cursor: grab !important;
  }

  .wy-experience-and-automation-page .performance-compare-group-by {
    height: 25px;
    .el-select.date-range-dropdown.el-select--mini {
      width: 6.86vw !important;
      min-width: 128px;
      border: 0px #DCDFE6 solid;
      border-radius: 5px;
      position: relative;
      right: 0.24vw;
      float: right;
      top: -5px;
      margin-right: 15px;
    }
    .el-select.date-range-dropdown.el-select--mini:focus {
      border: 1px solid #1C4DB2;
    }
    .el-select.date-range-dropdown.el-select--mini.blue-border{
      // border: 1px #106FBC solid;
    }
    .el-select.date-range-dropdown.el-select--mini:active{
      border: 0px #DCDFE6 solid !important;
    }
    .el-input.el-input--mini.el-input--suffix {
      border: 1px #DCDFE6 solid;
      border-radius: 5px;
    }
    .el-input.el-input--mini.el-input--suffix.is-focus {
      border: 1px solid #1C4DB2;
      input.el-input__inner {
        background: transparent !important;
      }
    }
    .el-input .el-select__caret.is-reverse {
      color: #1C4DB2;
      font-weight: 600;
    }
    input.el-input__inner {
      border-width: 0px 0px 1px 0px !important;
      border-radius: 5px;
      padding-left: 10px;
    }
    .el-input__inner {
      border: 1px solid transparent !important;
      &:hover{
        background: #F4F6F8;
      }
    }
    .el-input__inner {
      font-family: "Helvetica Neue", Helvetica !important;
      border-radius: 5px;
      padding: 8px 12px;
      font-size: 14.22px;
      font-family: Helvetica Neue, Helvetica;
      color: var(--site-font-tertiary-color);
      font-weight: normal;
      &:hover{
        background: #F4F6F8;
      }
    }
    .table-filter-dropdown .el-select-dropdown__item {
      height: 29px;
      line-height: 33px;
      font-weight: normal;
      font-size: 14px;
      padding: 0 10px;
      margin: 2px 0px 0px 0px !important;
      &:hover{
        background: #F4F6F8 !important;
      }
      // &:active{
      //   background: #E8F1FF !important;
      //   color: #1C4DB2;
      // }
    }
    .table-filter-dropdown .el-select-dropdown__item.selected {
      border: none;
      background-image: none !important;
      background: #E8F1FF !important;
      color: #1C4DB2;
    }
    .table-filter-dropdown {
      top: 20px !important;
    }
  }
  
  @media screen and (max-width: 1400px) {
    .wy-home-line-chart {
      g.yaxislayer-above .ytick text {
        font-size: 0.85vw !important;
      }
      g.xaxislayer-above .xtick text{
        font-size: 0.85vw !important;
      }
      .legendtext {
        font-size: 0.85vw !important;
      }
    }
  }

  .table-filter-dropdown.bes-bas-date-range {
    width: 6.53vw;
  }
  
</style>